module.exports = __webpack_public_path__ + "static/media/IOSAppStoreLinkQRcode.172e062e.jpg";